import { app } from '../../../../bootstrap/core';
import { adviserForm } from './adviserForm.component';

app.component('adviserForm', adviserForm);
